import React from 'react'
import { useTranslation } from 'react-i18next'
import { Callout, Combobox, ComboboxGroupProps, ComboboxProps } from '@node-space/ui-components'
import { useCustomersWalletsDropdown } from './useCustomersWalletsDropdown'

type CustomersWalletsDropdownProps = (ComboboxProps | ComboboxGroupProps) & {
  customerId: string
}

export const CustomersWalletsDropdown = ({
  customerId,
  ...cbbProps
}: CustomersWalletsDropdownProps) => {
  const { t } = useTranslation()
  const { isFetching, customerWalletOptions, onCustomerWalletChange, setQuery, isEmpty } =
    useCustomersWalletsDropdown(customerId)

  return (
    <>
      {isEmpty ? (
        <Callout variant="warning">{t('noWallets')}</Callout>
      ) : (
        <Combobox
          testId="customer-wallet"
          key={`customer-wallet-${customerId}-${cbbProps.defaultValue}`}
          {...cbbProps}
          label={t('wallets.convert.selectCustomerWallet')}
          onChange={onCustomerWalletChange}
          items={customerWalletOptions}
          loading={isFetching}
          loadingInline={isFetching}
          onInputChange={setQuery}
          modal
        />
      )}
    </>
  )
}
